import * as PaymentTypeIcons from './PaymentTypeIcons';

export default PaymentTypeIcons;
